import { state } from './state.js';

const KEY_HI = 'neonix_hi';
const KEY_SETTINGS = 'neonix_settings';

export function loadHi(): void {
  try {
    state.hiScore = parseInt(localStorage.getItem(KEY_HI) || '0', 10) || 0;
  } catch {
    state.hiScore = 0;
  }
}

export function saveHi(): void {
  try {
    if (state.score > state.hiScore) {
      state.hiScore = state.score;
      localStorage.setItem(KEY_HI, String(state.hiScore));
    }
  } catch {
    // ignore
  }
}

export function loadSettings(): void {
  try {
    const raw = localStorage.getItem(KEY_SETTINGS);
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (typeof parsed.sfxVolume === 'number') state.sfxVolume = clamp01(parsed.sfxVolume);
    if (typeof parsed.musicVolume === 'number') state.musicVolume = clamp01(parsed.musicVolume);
    if (typeof parsed.streamerMode === 'boolean') state.streamerMode = parsed.streamerMode;
  } catch {
    // ignore
  }
  applyStreamerMode();
}

export function saveSettings(): void {
  try {
    localStorage.setItem(KEY_SETTINGS, JSON.stringify({
      sfxVolume: state.sfxVolume,
      musicVolume: state.musicVolume,
      streamerMode: state.streamerMode,
    }));
  } catch {
    // ignore
  }
  applyStreamerMode();
}

/**
 * Toggle the .streamer-mode class on <body>. CSS hides non-essential
 * chrome (header tagline, footer keyboard-shortcuts hint, world tag,
 * touch hint) when the class is set so streamers/recorders get a
 * clean stage with just the game + score + timer.
 */
export function applyStreamerMode(): void {
  if (typeof document === 'undefined') return;
  document.body.classList.toggle('streamer-mode', state.streamerMode);
}

function clamp01(n: number): number {
  return Math.max(0, Math.min(1, n));
}
